<app-base-template (modal)="openModal(content)"(dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">User Filter</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected">
                <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
            </select>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="filter()">Submit</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>
<notifier-container></notifier-container>